export default __webpack_public_path__ + "static/media/profile-placeholder-bp.abda4f4f.png";